import { useState, useEffect } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';

import Image from '@/components/Image';
import Popup from '@/components/mobile/Popup';
import 'swiper/css';

const ImagePreview = ({ visible, onClose, images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!visible) {
      setCurrentIndex(0);
    }
  }, [visible]);

  const handleSlideChange = (swiper) => {
    setCurrentIndex(swiper.realIndex);
  };

  return (
    <Popup visible={visible} onClose={onClose}>
      <Swiper className="w-[300px] h-[300px]" spaceBetween={10} slidesPerView={1} onSlideChange={handleSlideChange}>
        {images.map((image, index) => (
          <SwiperSlide key={index} className="flex items-center justify-center">
            <Image
              src={image || 'https://static.szlcsc.com/ecp/assets/app/product-list/nothing.png'}
              width={300}
              height={300}
              alt={`Image ${index + 1}`}
              className="rounded-[8px] object-contain"
              fallback="https://static.szlcsc.com/ecp/assets/app/product-list/nothing.png"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="absolute bottom-[10px] right-[10px] p-[2px] bg-black bg-opacity-10 text-white rounded-[12px] text-[12px] leading-[13px] z-10">
        {currentIndex + 1}&nbsp;|&nbsp;{images.length}
      </div>
    </Popup>
  );
};

export default ImagePreview;
